import { getLocales } from "expo-localization";

import { isWeb, setupI18n } from "@stepapp/core";
import en from "./locales/en_GB.json";
import no from "./locales/nb_NO.json";
import pl from "./locales/pl_PL.json";
import sv from "./locales/sv_SE.json";
import uk from "./locales/uk_UA.json";

const href = window?.location?.href;
const defaultLanguage = isWeb
  ? href?.includes(".no")
    ? "no"
    : "pl"
  : (getLocales()[0]?.languageCode as keyof typeof resources) || "pl";

const resourcesTypes = {
  pl,
  en,
  no,
  sv,
  uk,
} as const;

const resources = {
  pl: { translation: pl },
  en: { translation: en },
  no: { translation: no },
  sv: { translation: sv },
  uk: { translation: uk },
} as const;

export const i18n = setupI18n({
  options: {
    lng: defaultLanguage,
    resources,
  },
});

declare module "i18next" {
  // Extend CustomTypeOptions
  interface CustomTypeOptions {
    defaultNS: typeof defaultLanguage;
    resources: typeof resourcesTypes;
  }
}
